import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React from 'react';
import { ChevronIcon, MoreIcon } from '@chegg-ui/theme';
import { sessionLogger } from '@chegg-ui/utils';
import { clickBaseEvent, signInRioLog } from '@chegg-me-components/utils';
import { DropdownUL, NavDropdownLink, BlackStyledToggletip, CaretButton, BorderedAvatar, UserDropdownInfo, UserDropdownInfoLink, UserDropdownTextContainer, UserInfo, UserName, UserEmail, ThreeDots, DropdownLI, PaddedAvatar, SignInLink, Divider, StyledToggletip, DesktopUserMenuContainer, CreateAccountLink } from '../../styles';
import { NavType } from '../../types';
import { rioClient } from './../rio';

var DesktopUserMenu = function DesktopUserMenu(_ref) {
  var navType = _ref.navType,
      user = _ref.user,
      envUrl = _ref.envUrl,
      pageTrackId = _ref.pageTrackId,
      onClickSignIn = _ref.onClickSignIn,
      onClickSignUp = _ref.onClickSignUp,
      userLinks = _ref.userLinks;

  var logUserMenuClick = function logUserMenuClick(logValue) {
    sessionLogger.event(envUrl, pageTrackId, {
      usermenu_click: logValue
    });
  }; // TODO infra: memoize links? https://chegg.atlassian.net/browse/CUI-368


  var dropdownLinkComponents = userLinks.map(function (linkDetails) {
    return /*#__PURE__*/React.createElement(DropdownLI, {
      key: linkDetails.text
    }, /*#__PURE__*/React.createElement(NavDropdownLink, {
      href: "".concat(envUrl).concat(linkDetails.href),
      redirect: linkDetails.shouldRedirectBack,
      "data-test": "header-more-".concat(linkDetails.loggingKey),
      onClick: function onClick(e) {
        logUserMenuClick(linkDetails.loggingKey);
        rioClient.sendEvent(_objectSpread(_objectSpread({}, clickBaseEvent), {}, {
          data: {
            interaction: {
              type: 'select',
              element: {
                name: user ? 'nav user shortcut item' : 'nav more shortcut item',
                type: 'link',
                region_name: user ? 'user nav header' : 'nav header',
                value: linkDetails.text
              }
            }
          },
          options: {
            force: true
          }
        }));

        if (linkDetails.onClick) {
          linkDetails.onClick(e);
        }
      }
    }, /*#__PURE__*/React.createElement("span", null, linkDetails.text)));
  });
  return /*#__PURE__*/React.createElement(DesktopUserMenuContainer, null, user ? /*#__PURE__*/React.createElement(BlackStyledToggletip, {
    position: "bottomLeft",
    targetElement: /*#__PURE__*/React.createElement(CaretButton, {
      onClick: function onClick() {
        /**
         * Rio log when user click on user button
         * after signing in
         */
        rioClient.sendEvent(_objectSpread(_objectSpread({}, clickBaseEvent), {}, {
          data: {
            interaction: {
              type: 'expand',
              element: {
                name: 'nav user shortcut',
                type: 'drop down',
                region_name: 'nav header'
              }
            }
          }
        }));
      },
      "data-test": "header-more-dropdown",
      screenReaderOnlyText: "account"
    }, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(BorderedAvatar, {
      size: 'small',
      name: user.fname,
      image: {
        src: user.avatar,
        alt: ''
      }
    }), /*#__PURE__*/React.createElement(ChevronIcon, {
      size: "xsmall"
    })))
  }, /*#__PURE__*/React.createElement(DropdownUL, null, /*#__PURE__*/React.createElement(UserDropdownInfo, null, /*#__PURE__*/React.createElement(UserDropdownInfoLink, {
    href: "".concat(envUrl, "my/profile"),
    onClick: function onClick() {
      return logUserMenuClick('my-profile');
    },
    "data-test": "header-more-my-profile"
  }, /*#__PURE__*/React.createElement(PaddedAvatar, {
    size: 'medium',
    name: user.fname,
    image: {
      src: user.avatar,
      alt: ''
    }
  }), /*#__PURE__*/React.createElement(UserDropdownTextContainer, null, /*#__PURE__*/React.createElement(UserInfo, null, user.fname && /*#__PURE__*/React.createElement(UserName, null, user.fname, " ", user.lname), /*#__PURE__*/React.createElement(UserEmail, null, user.emailShow)), /*#__PURE__*/React.createElement(ThreeDots, null, /*#__PURE__*/React.createElement(MoreIcon, {
    size: "xsmall"
  }))))), dropdownLinkComponents)) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(SignInLink, {
    redirect: true,
    href: navType === NavType.uversity ? "".concat(envUrl, "uversity/auth?auth=login") : "".concat(envUrl, "login"),
    "data-test": "header-signin",
    onClick: function onClick(e) {
      logUserMenuClick('signin');

      if (onClickSignIn) {
        onClickSignIn(e);
      }
      /**
       * Sign in Rio Event for desktop
       */


      signInRioLog();
    }
  }, "Sign in"), /*#__PURE__*/React.createElement(Divider, null), navType === NavType.uversity ? /*#__PURE__*/React.createElement(CreateAccountLink, {
    redirect: true,
    href: "".concat(envUrl, "uversity/auth?auth=signup"),
    "data-test": "header-create-account",
    onClick: function onClick(e) {
      logUserMenuClick('signup');

      if (onClickSignUp) {
        onClickSignUp(e);
      }
    }
  }, "Create account") : /*#__PURE__*/React.createElement(StyledToggletip, {
    position: "bottomLeft",
    targetElement: /*#__PURE__*/React.createElement(CaretButton, {
      onClick: function onClick() {
        /**
         * when users click on more button
         * in nav
         */
        rioClient.sendEvent(_objectSpread(_objectSpread({}, clickBaseEvent), {}, {
          data: {
            interaction: {
              type: 'expand',
              element: {
                name: 'nav more options',
                type: 'drop down',
                region_name: 'nav header'
              }
            }
          }
        }));
      },
      screenReaderOnlyText: "more links",
      "data-test": "header-more-dropdown"
    }, /*#__PURE__*/React.createElement(React.Fragment, null, "More", /*#__PURE__*/React.createElement(ChevronIcon, {
      size: "xsmall"
    })))
  }, /*#__PURE__*/React.createElement(DropdownUL, null, dropdownLinkComponents))));
};

DesktopUserMenu.displayName = 'DesktopUserMenu';
export default DesktopUserMenu;